import cnLogo1 from "../images/cn/logo1.png"
import cnLogo2 from "../images/cn/logo2.png"
import cnLogo3 from "../images/cn/logo3.png"
import cnLogo4 from "../images/cn/logo4.png"
import cnLogo5 from "../images/cn/logo5.png"
import cnLogo6 from "../images/cn/logo6.png"
import cnLogo7 from "../images/cn/logo7.png"
import cnLogo8 from "../images/cn/logo8.png"
import cnLogo9 from "../images/cn/logo9.png"
import cnLogo10 from "../images/cn/logo10.png"
import cnLogo11 from "../images/cn/logo11.png"
import cnLogo13 from "../images/cn/logo13.png"




import { UserLogoMapMobileType } from 'globalCommon/utils/index'

export const UserLogoMap: UserLogoMapMobileType = {
    cn: [cnLogo1, cnLogo2, cnLogo3, cnLogo4, cnLogo9, cnLogo13, cnLogo10, cnLogo11, cnLogo5, cnLogo6, cnLogo7, cnLogo8],



};
